/**
 * Returns a list of all valid sell options for a deviation.
 *
 * Relies on extended deviation data being loaded.
 */ export function getSellableAs(item) {
    var _item_extended;
    var _item_extended_sellableAs;
    return (_item_extended_sellableAs = (_item_extended = item.extended) === null || _item_extended === void 0 ? void 0 : _item_extended.sellableAs) !== null && _item_extended_sellableAs !== void 0 ? _item_extended_sellableAs : [];
}
export function getIsStash(item) {
    return !!item.stashPrivateid;
}
export function getDreamupPrompt(item) {
    var _item_extended_dreamsofart, _item_extended;
    return (_item_extended = item.extended) === null || _item_extended === void 0 ? void 0 : (_item_extended_dreamsofart = _item_extended.dreamsofart) === null || _item_extended_dreamsofart === void 0 ? void 0 : _item_extended_dreamsofart.prompt;
}

//# sourceMappingURL=getters.js.map